import { TranslationKey } from './../../../../../../types/translation/TranslationKey';

import { t } from '../../../../../../types/translation/Translator';
import React from 'react';

import { testIds } from '../../../../../../util/identifiers/identifiers.util';
import { Button, ButtonProps, ButtonTemplateProps } from '../../Button';

export function NextButtonTemplate(onClick: () => void, props?: ButtonTemplateProps): ButtonProps {
  return {
    testId: testIds.next,
    style: 'secondary',
    text: t(TranslationKey.next).singular.label,
    onClick: onClick,
    ...props,
  };
}

interface NextButtonProps extends ButtonTemplateProps {
  onClick: () => void;
}

export default function NextButton({ onClick, ...props }: NextButtonProps) {
  return <Button {...NextButtonTemplate(onClick, props)} />;
}
